import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import type {
  ScreenDataUpdateResponse,
  UsernameResponse,
  TeacherUsernameResponse,
  BackgroundListGetResponse,
  UserBackgroundListGetResponse,
  BoardInfo,
  BoardInfoGetResponse,
  BoardLastPageResponse,
  BoardListGetResponse,
  ImageListGetResponse,
  BoardElementListGetResponse,
  BoardDrawDataGetResponse,
  MemberListGetResponse,
  CardListGetResponse,
  BoardDrawDataCreateResponse,
  BoardElementListCopyRequest,
  State,
} from "./types";
import type { RootState } from "../types";

// Define the initial state using that type
const initialState: State = {
  errorMsg: "",
  screenDataGetPending: false,
  success: false,
  screenData: {
    screenHeight: 0,
    screenWidth: 0,
  },
  username: null,
  teacherUsername: null,
  //
  pageInfo: {
    pageNum: 0,
    total: 0,
  },
  backgroundCategoryGetPending: false,
  backgroundCategorys: [],
  backgroundListGetPending: false,
  backgrounds: [],
  userBackgroundListGetPending: false,
  userUploads: [],
  boardData: null,
  boardInfo: null,
  boardListGetPending: false,
  boardUpdateSuccess: false,
  boards: [],
  images: [],
  boardElements: [],
  members: [],
  cards: [],
  works: [],
  draw_id: null,
  drawData: null,
  boardDarwDataUpdateSuccess: false,
  //
  copyStore: "",
  boardElementsCopySuccess: false,
  pasteCount: 1,

  stop_socket: false,



};

export const screenSlice = createSlice({
  // `createSlice` will infer the state type from the `initialState` argument
  initialState,

  name: "screen",
  reducers: {
    // Use the PayloadAction type to declare the contents of `action.payload`
    screenDataUpdate: (state, action: PayloadAction<ScreenDataUpdateResponse>) => {
      const { screenHeight, screenWidth } = action.payload;
      state.screenData.screenHeight = screenHeight;
      state.screenData.screenWidth = screenWidth;
    },
    screenDataUpdateError: (state, action: PayloadAction<string>) => {
      state.errorMsg = action.payload;
    },
    //
    usernameUpdate: (state, action: PayloadAction<UsernameResponse>) => {
      state.username = action.payload.username;
    },
    usernameUpdateError: (state, action: PayloadAction<string>) => {
      state.errorMsg = action.payload;
    },
    //
    teacherUsernameSet: (state, action: PayloadAction<TeacherUsernameResponse>) => {
      state.teacherUsername = action.payload.teacherUsername;
    },
    teacherUsernameSetError: (state, action: PayloadAction<string>) => {
      state.errorMsg = action.payload;
    },
    //
    backgroundCategoryGetPending: state => {
      state.backgroundCategoryGetPending = true;
    },
    backgroundCategoryGetError: (state, action: PayloadAction<string>) => {
      state.backgroundCategoryGetPending = false;
      state.errorMsg = action.payload;
    },
    backgroundCategoryGetSuccess: (state, action: PayloadAction<BackgroundListGetResponse>) => {
      state.backgroundCategoryGetPending = false;
      state.backgroundCategorys = action.payload.list;
    },
    backgroundListGetPending: state => {
      state.backgroundListGetPending = true;
    },
    backgroundListGetError: (state, action: PayloadAction<string>) => {
      state.backgroundListGetPending = false;
      state.errorMsg = action.payload;
    },
    backgroundListGetSuccess: (state, action: PayloadAction<BackgroundListGetResponse>) => {
      state.backgroundListGetPending = false;
      state.backgrounds = action.payload.list;
    },
    userBackgroundListGetPending: state => {
      state.userBackgroundListGetPending = true;
    },
    userBackgroundListGetError: (state, action: PayloadAction<string>) => {
      state.userBackgroundListGetPending = false;
      state.errorMsg = action.payload;
    },
    userBackgroundListGetSuccess: (state, action: PayloadAction<UserBackgroundListGetResponse>) => {
      state.userBackgroundListGetPending = false;
      state.userUploads = action.payload.data;
    },
    boardInfoGetError: (state, action: PayloadAction<string>) => {
      state.errorMsg = action.payload;
    },
    boardInfoGetSuccess: (state, action: PayloadAction<BoardInfoGetResponse>) => {
      state.boardData = action.payload.data;
    },
    boardLastPageError: (state, action: PayloadAction<string>) => {
      state.errorMsg = action.payload;
    },
    boardLastPageSuccess: (state, action: PayloadAction<BoardLastPageResponse>) => {
      state.boardData = action.payload.data;
    },
    boardListGetPending: state => {
      state.boardListGetPending = true;
    },
    boardListGetError: (state, action: PayloadAction<string>) => {
      state.boardListGetPending = false;
      state.errorMsg = action.payload;
    },
    boardListGetSuccess: (state, action: PayloadAction<BoardListGetResponse>) => {
      const { data, pageNum, stop_socket } = action.payload;
      state.boardUpdateSuccess = true;
      state.boardListGetPending = false;
      state.boards = data;
      state.boardInfo = data[pageNum];
      state.pageInfo = {
        pageNum,
        total: data.length,
      }
      state.stop_socket = stop_socket;
    },
    boardPageNumSetting: (state, action: PayloadAction<any>) => {
      state.boardInfo = state.boards[action.payload];
      state.pageInfo = {
        pageNum: action.payload,
        total: state.boards.length,
      }
    },
    resetboardUpdateFlag: state => {
      state.boardUpdateSuccess = false;
      // state.errorMsg = "";
    },
    boardPageCreateError: (state, action: PayloadAction<string>) => {
      state.boardListGetPending = false;
      state.errorMsg = action.payload;
    },
    boardPageCreateSuccess: (state, action: PayloadAction<string | null>) => {
      state.success = true;
      state.boardListGetPending = false;
      // state.errorMsg = "";
    },
    boardPageDeleteError: (state, action: PayloadAction<string>) => {
      state.boardListGetPending = false;
      state.errorMsg = action.payload;
    },
    boardPageDeleteSuccess: (state, action: PayloadAction<string | null>) => {
      state.success = true;
      state.boardListGetPending = false;
      // state.errorMsg = "";
    },
    boardPageCopyError: (state, action: PayloadAction<string>) => {
      state.boardListGetPending = false;
      state.errorMsg = action.payload;
    },
    boardPageCopySuccess: (state, action: PayloadAction<string | null>) => {
      state.success = true;
      state.boardListGetPending = false;
      // state.errorMsg = "";
    },
    resetBoardPageFlag: state => {
      state.success = false;
      // state.errorMsg = "";
    },
    imageListGetError: (state, action: PayloadAction<string>) => {
      state.errorMsg = action.payload;
    },
    imageListGetSuccess: (state, action: PayloadAction<ImageListGetResponse>) => {
      state.images = action.payload.data;
    },
    boardElementListGetError: (state, action: PayloadAction<string>) => {
      state.errorMsg = action.payload;
    },
    boardElementListGetSuccess: (state, action: PayloadAction<BoardElementListGetResponse>) => {
      state.boardElements = action.payload.data;
    },
    boardElementCreateError: (state, action: PayloadAction<string>) => {
      state.errorMsg = action.payload;
    },
    boardElementCreateSuccess: (state, action: PayloadAction<string | null>) => {
      state.success = true;
      // state.errorMsg = "";
    },
    boardElementDeleteError: (state, action: PayloadAction<string>) => {
      state.errorMsg = action.payload;
    },
    boardElementDeleteSuccess: (state, action: PayloadAction<string | null>) => {
      state.success = true;
      // state.errorMsg = "";
    },
    memberListGetError: (state, action: PayloadAction<string>) => {
      state.errorMsg = action.payload;
    },
    memberListGetSuccess: (state, action: PayloadAction<MemberListGetResponse>) => {
      state.members = action.payload.data;
    },
    memberCreateError: (state, action: PayloadAction<string>) => {
      state.errorMsg = action.payload;
    },
    memberCreateSuccess: (state, action: PayloadAction<string | null>) => {
      state.success = true;
      state.errorMsg = "";
    },
    cardListGetError: (state, action: PayloadAction<string>) => {
      state.errorMsg = action.payload;
    },
    cardListGetSuccess: (state, action: PayloadAction<CardListGetResponse>) => {
      state.cards = action.payload.data;
    },
    cardCreateError: (state, action: PayloadAction<string>) => {
      state.errorMsg = action.payload;
    },
    cardCreateSuccess: (state, action: PayloadAction<string | null>) => {
      state.success = true;
      state.errorMsg = "";
    },
    workListGetSuccess: (state, action: PayloadAction<any>) => {
      state.works = action.payload;
    },
    workCreateError: (state, action: PayloadAction<string>) => {
      state.errorMsg = action.payload;
    },
    setError: (state, action: PayloadAction<string>) => {
      state.errorMsg = action.payload;
    },
    //
    boardDarwDataGetError: (state, action: PayloadAction<string>) => {
      state.errorMsg = action.payload;
    },
    boardDarwDataGetSuccess: (state, action: PayloadAction<any>) => {
      state.draw_id = action.payload.id;
      state.drawData = action.payload.data;
    },
    boardDarwDataCreateError: (state, action: PayloadAction<string>) => {
      state.errorMsg = action.payload;
    },
    boardDarwDataCreateSuccess: (state, action: PayloadAction<BoardDrawDataCreateResponse>) => {
      state.draw_id = action.payload.data.id;
      state.success = true;
      state.errorMsg = "";
    },
    boardDarwDataUpdateError: (state, action: PayloadAction<string>) => {
      state.errorMsg = action.payload;
    },
    boardDarwDataUpdateSuccess: (state, action: PayloadAction<string | null>) => {
      state.boardDarwDataUpdateSuccess = true;
      state.errorMsg = "";
    },
    resetboardDarwDataUpdateFlag: state => {
      state.boardDarwDataUpdateSuccess = false;
      state.errorMsg = "";
    },
    boardElementsCopySuccess: (state, action: PayloadAction<string>) => {
      state.boardElementsCopySuccess = true;
      state.copyStore = action.payload;
    },
    boardElementsCopyForNowPageSuccess: (state, action: PayloadAction<string>) => {
      state.copyStore = action.payload;
    },
    resetBoardElementsCopyFlag: state => {
      state.boardElementsCopySuccess = false
    },
    setPasteCount: (state, action: PayloadAction<number>) => {
      state.pasteCount = action.payload;
    },
  },
});

export const {
  screenDataUpdate,
  screenDataUpdateError,
  usernameUpdate,
  usernameUpdateError,
  teacherUsernameSet,
  teacherUsernameSetError,
  //
  backgroundCategoryGetPending,
  backgroundCategoryGetError,
  backgroundCategoryGetSuccess,
  backgroundListGetPending,
  backgroundListGetError,
  backgroundListGetSuccess,
  userBackgroundListGetPending,
  userBackgroundListGetError,
  userBackgroundListGetSuccess,
  boardInfoGetError,
  boardInfoGetSuccess,
  boardLastPageError,
  boardLastPageSuccess,
  boardListGetPending,
  boardListGetError,
  boardListGetSuccess,
  boardPageNumSetting,
  resetboardUpdateFlag,
  boardPageCreateError,
  boardPageCreateSuccess,
  boardPageDeleteError,
  boardPageDeleteSuccess,
  boardPageCopyError,
  boardPageCopySuccess,
  resetBoardPageFlag,
  imageListGetError,
  imageListGetSuccess,
  boardElementListGetError,
  boardElementListGetSuccess,
  boardElementCreateError,
  boardElementCreateSuccess,
  boardElementDeleteError,
  boardElementDeleteSuccess,
  memberListGetError,
  memberListGetSuccess,
  memberCreateError,
  memberCreateSuccess,
  cardListGetError,
  cardListGetSuccess,
  cardCreateError,
  cardCreateSuccess,
  workListGetSuccess,
  workCreateError,
  setError,
  boardDarwDataGetError,
  boardDarwDataGetSuccess,
  boardDarwDataCreateError,
  boardDarwDataCreateSuccess,
  boardDarwDataUpdateError,
  boardDarwDataUpdateSuccess,
  resetboardDarwDataUpdateFlag,
  boardElementsCopySuccess,
  boardElementsCopyForNowPageSuccess,
  resetBoardElementsCopyFlag,
  setPasteCount,
} = screenSlice.actions;

export const screenState = (state: RootState) => state.screen as State;

export default screenSlice.reducer;
